module.exports = __webpack_public_path__ + "static/media/droplet.2775f655.png";